module.exports = __webpack_public_path__ + "img/Tools.f9d4b098.svg";